import { Pipe, PipeTransform } from '@angular/core';
import { conformToMask } from 'angular2-text-mask';

@Pipe({
    name: 'cnpj'
})
export class CnpjPipe implements PipeTransform {

    transform(cnpj: string): string {
        return conformToMask(
            cnpj,

            // 81.905.726/0001-75
            [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
            { guide: false })
            .conformedValue
    }
}
